// extracted by mini-css-extract-plugin
export default {"ThemeSwitch":"ThemeSwitch_ThemeSwitch__9CXnc","Dark":"ThemeSwitch_Dark__zU3K1"};